import React from "react";
import { Link } from "react-router-dom";

const ERPEmplimentation = () => {
  return (
    <>
    <div className="container-fluid p-0 banner-section"  style={{backgroundImage: "url('img/erp.jpg')"}}>
       <div className="overlay"></div>
        <div className="row">
        <div className="col-md-12 mt-5 text-white text-center">
           <h1 className="pt-5 mt-5 ">ERP Implimentation</h1>
          <nav>
            <ol className="breadcrumb justify-content-center bg-transparent">
              <li className="breadcrumb-item">
                <Link to="/" className="text-white text-decoration-none">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active text-white" aria-current="page">
               ERP Implimentation
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

 <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
          <img
            src="/img/transform.jpg"
            alt="ERP Implementation Services"
            className="img-fluid rounded-3"
          />
        </div>

        <div className="col-lg-6 col-md-6 col-12">
          <h2 className="fw-bold mb-1">Comprehensive ERP Implementation</h2>
          <p className="fs-5 py-1">
           At DigiOpen Services, during ERP implementation, we deploy, configure, and integrate software to centralise
data, standardise workflows, and automate business processes across finance, HR, and supply chain. Key
functions include system customisation, data migration, user training, and strategic advisory services to
improve operational agility and efficiency across the enterprise.
          </p>
                    <p className="fs-5 py-1">
        Key Business Areas Transformed:

Finance & Accounting: Managing general ledgers, accounts payable/receivable, and automated reporting.

Order Management: Order entry, Order processing, coordinating the order-to-cash process, including
shipping and invoicing.

Sales -sales analysis ,pricing,

Supply Chain Management: Optimising supplier scheduling, available to promise, inventory management, and
warehousing.</p>
        </div>

      </div>
    </div>

<div className="container py-5">
      <div className="row align-items-center">
       <div className="col-lg-6 col-md-6 col-12">
          <h2 className="fw-bold mb-1">Enterprise Engagements</h2>
          <p className="fs-5 py-1">
         Larger enterprises with dedicated IT teams, engage DigiOpen Services in all or some of these activities that form a part of their business system implementation process.
   Perform/Support product evaluation and participate in the comparison of choices
Prepare a blue-print defining the functional solution against requirements provided by them
Execute the product implementation project. Implementation process is iterative, with weekly/fortnightly releases to a customer test environment, where the features are shown and adjusted for customer feedback.
Execute sub-projects related to data migration and integration either entirely or in collaboration with the customer IT team
Skill of members of the customer team to enhance the solution and also in providing level 1 support internally for the other employees.
          </p>
        </div>

  <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
          <img
            src="/img/productidea.jpg" width="100%" height="70%"
            alt="ERP Implementation Services"
            className="img-fluid rounded-3"
          />
        </div>
      </div>
    </div>

 <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
          <img
            src="/img/maintance.png"
            alt="ERP Implementation Services"
            className="img-fluid rounded-3"
          />
        </div>

        <div className="col-lg-6 col-md-6 col-12">
          <h2 className="fw-bold mb-1">Maintenance and Support</h2>
          <p className="fs-5 py-1">
           This is for customers of large implementations who need an expert team to take over and maintain their implementation in a cost effective way. This includes supporting for the production implementation, performing upgrades to the core product and executing projects to extend the product usage or integrate it with other systems. Support services generally include functional and technical support on the product but can also include infrastructure support for servers which can either be in a data centre or on cloud.
          </p>
        
        </div>

      </div>
    </div>

<div className="container py-5">
      <div className="row align-items-center">
       <div className="col-lg-6 col-md-6 col-12">
          <h2 className="fw-bold mb-1">Project Implementation</h2>
          <p className="fs-5 py-1">
         This is for customers who have an existing ERP implementation and want to execute specific projects to enhance it's capabilities. Some projects that DigiOpen Services has executed in the past include building mobile front-end solutions for the ERP, developing a data-warehouse with data from the ERP and other systems or providing an integration with other systems. DigiOpen Services offers fixed price as well as T&M based project proposals for such engagements and provides free one year warranty support for bug fixes.</p></div>

  <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
          <img
            src="/img/projectimp.webp" width="100%" height="70%"
            alt="ERP Implementation Services"
            className="img-fluid rounded-3"
          />
        </div>
      </div>
    </div>

 <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-lg-6 col-md-6 col-12 mb-4 mb-md-0">
          <img
            src="/img/maintance.png"
            alt="ERP Implementation Services"
            className="img-fluid rounded-3"
          />
        </div>

        <div className="col-lg-6 col-md-6 col-12">
          <h2 className="fw-bold mb-1">Implementation Rescue</h2>
          <p className="fs-5 py-1">
          DigiOpen Services also execute rescue engagements, where a customer implementing the ERP finds it stalled or not meeting business expectations. A typical rescue engagement starts with an audit based on which a situation assessment and recommendations are provided. The next stage is to provide a plan that provides predictability of delivery to the customer, while also harvesting existing partially implemented features to the extent possible and execute the same as a project.
          </p>
        
        </div>

      </div>
    </div>

    </>
  );
};

export default ERPEmplimentation;